import { FC } from "react";
import { formatPhoneNumber } from "src/helpers";
interface ConfirmPhoneModalProps {
    onClose: () => void;
    onConfirm: () => void;
    phoneNumber: string;
}

const ConfirmPhoneModal: FC<ConfirmPhoneModalProps> = ({ onClose, onConfirm, phoneNumber }) => {
    return (
        <div
            className="modal show d-flex align-items-center justify-content-center"
            style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
            }}
            onClick={onClose}
        >
            <div className="modal-dialog modal-md" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content shadow">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirm Phone Number</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>Please confirm the number provided is the accurate number to reach the patient:</p>
                        <p className="fw-bold text-center fs-4">{formatPhoneNumber(phoneNumber)}</p>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                        <button className="btn btn-primary" onClick={onConfirm}>Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmPhoneModal;
